import React, { useState } from "react";
import { Oval } from "react-loader-spinner";
import "../styles/register.css";

const RegisterEmail = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const validateEmail = (email) => /\S+@\S+\.\S+/.test(email);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateEmail(email)) {
      alert("Digite um e-mail válido.");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(
        `${import.meta.env.VITE_BACKEND_URL}/api/auth/register-email`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        }
      );
      const data = await res.json();
      if (res.ok) {
        window.location.href = "/email-enviado";
      } else {
        alert(data.error || "Erro ao cadastrar e-mail.");
      }
    } catch (err) {
      console.error(err);
      alert("Erro ao conectar ao servidor.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-page">
      <form onSubmit={handleSubmit} className="register-form">
        <input
          type="email"
          name="email"
          placeholder="Seu e-mail"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit" disabled={loading} className="btn custom-login-btn w-100">
          {loading ? (
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span>Enviando...</span>
              <Oval height={18} width={18} />
            </div>
          ) : (
            "Enviar"
          )}
        </button>
        <p className="register-disclaimer">
          <strong>Não é necessário cartão de crédito.</strong><br />
          Ao clicar em <b>Enviar</b>, você concorda com nossos <a href="/termos" target="_blank">termos de serviço</a>.
        </p>
      </form>
    </div>
  );
};

export default RegisterEmail;